import React, { useEffect, useState } from 'react'
import Select from 'react-select';
import { BuildTalents, getDefaultName } from '../utils'
import { loadCity, loadCourses, loadJuries, loadTalents } from '../utils/Network'
import { makeDarkSelectStyles } from './selectStyles';

export default function SelectMenu({ callback, value, width ,name="menu" }) {

    const [SelectOptions, setSelectOptions] = useState([]);

    const customStyles = makeDarkSelectStyles({ width: width || '200px' });

    
    var options = [
        {
            label: "Show",
            value: true
        },
        {
            label : "Hide",
            value : false
        },
    ]

    const handleSelect = (e) => {
        var value = e.value;
        callback(value, name)

    }

    return (
        <>
            <div className="filter-select">
                <Select options={options}
                    styles={customStyles}
                    onChange={handleSelect}
                    placeholder="Menu"
                    value={options && options.filter(obj => obj.value === value)}


                />
            </div>
            
        </>
    )
}
